import PropTypes from 'prop-types';
import React, { Component } from "react";
import Relay from "react-relay"
import ButtonDropdown from "./ButtonDropdown"
import Icon from "./Icon"
import { Link } from "react-router"
import { FormattedMessage, injectIntl } from "react-intl"
import messages from "../../messages/sets"
import { getStyles } from '../../styles/dynamicStyles';

class SetBreadcrumb extends Component {
  state = {
    showSetDropdown: false
  }

  static propTypes = {
    singleSetTitle: PropTypes.string,
    viewer: PropTypes.object
  }

  static defaultProps = {
    singleSetTitle: null
  }

  render() {
    const {
      singleSetTitle,
      intl,
      viewer: { userSets }
    } = this.props
    const sets = userSets.edges.map(edge => edge.node)
    return (
      <h3 className="c-results-panel__title" style={getStyles('c-results-panel-sets__title')}>
        <div className="c-results-panel__title-dropdown">
          <ButtonDropdown
            title={intl.formatMessage(messages.selectSet)}
            triggerText={intl.formatMessage(messages.sets)}
            expanded={this.state.showSetDropdown}
            handleClick={e => {
              e.preventDefault()
              this.toggleDropDown()
            }}
            textStyle
            dropdownStyled
            dropdownHeightLimited
          >
            <ul className="link-list link-list--height-limited link-list--tiny">
              <li>
                <Link to="/user/sets">
                  <FormattedMessage {...messages.allSets} />
                </Link>
              </li>
              {sets.map(set => (
                <li key={set.id}>
                  <Link
                    to={`/user/sets/${set.id}`}
                    onClick={this.toggleDropDown}
                  >
                    {set.name === "Favourites" && (
                      <FormattedMessage {...messages.favourites} />
                    )}
                    {set.name !== "Favourites" && set.name}
                  </Link>
                </li>
              ))}
            </ul>
          </ButtonDropdown>
        </div>
        {singleSetTitle && (
          <span>
            <Icon icon="caret-right" />
            {singleSetTitle === "Favourites" && (
              <FormattedMessage {...messages.favourites} />
            )}
            {singleSetTitle !== "Favourites" && singleSetTitle}
          </span>
        )}
      </h3>
    )
  }

  toggleDropDown = () => {
    this.setState({
      showSetDropdown: !this.state.showSetDropdown
    })
  }
}

export default Relay.createContainer(injectIntl(SetBreadcrumb), {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        userSets: user_sets(first: 1000) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/elements/SetsBreadcrumb.js